export default __webpack_public_path__ + "assets/5200758d0019e59f1a07809436f7f0c6.webp";